// Tamaño del texto de toda la app (Perfil → Ajustes): Normal, Grande o Muy
// grande. Escala la raíz (html), así que todo lo que va en rem crece a la
// vez, y en porcentaje: respeta además el tamaño de letra que la persona
// tenga puesto en el navegador o el móvil. Se guarda en el dispositivo (para
// aplicarlo antes de pintar nada) y en el perfil (para que la siga en otros
// dispositivos).
export const TEXT_SCALES = ["normal", "large", "xlarge"];
const KEY = "colygon_text_scale";

export function applyTextScale(scale) {
  const value = TEXT_SCALES.includes(scale) ? scale : "normal";
  document.documentElement.dataset.textScale = value;
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // sin almacenamiento: vale para esta visita
  }
  return value;
}

export function initTextScale() {
  let saved = "normal";
  try {
    saved = localStorage.getItem(KEY) || "normal";
  } catch {
    // sin almacenamiento
  }
  applyTextScale(saved);
}

export const currentTextScale = () => document.documentElement.dataset.textScale || "normal";
